import type { ManualLeagueSettings } from '@pff-consumer/schema/fantasy-mds/manual-league-settings'

export const getBenchSpots = (starters: ManualLeagueSettings['starters'], numOfRounds: number) =>
  // @ts-expect-error
  numOfRounds - Object.keys(starters).reduce((prev, curr) => starters[curr] + prev, 0)
